export enum MeetingSettingType {
    Initial=1,
    Annual=5,
    Reevaluation=2,
    AdditionalReevaluation=3,
    Mandated3Year= 4,
    Waiver=6,
    Amendment=7,
    Reconvene=8,
    Assessment=9
  }